var _path, _g, _path2, _g2, _path3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 150,
    viewBox: "0 0 392 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7334_388815",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 150
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H119.73V150H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7334_388815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.383 85.3297H102.104V33.0481H75.737V85.3297H32.6213L84.4916 0.00842285H51.8647L0.00292969 85.3297V111.686H75.737V149.665H102.104V111.686H119.383V85.3297Z",
    fill: "#0096FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7334_388815",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 0,
    width: 121,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.768 0H391.23V150H271.768V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7334_388815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.227 85.3298H373.948V33.0482H347.589V85.3298H304.474L356.335 0.00854492H323.708L271.847 85.3298V111.686H347.589V149.665H373.948V111.686H391.227V85.3298Z",
    fill: "#FF3296"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7334_388815",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 0,
    width: 143,
    height: 150
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.62 0H267.35V150H125.62V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7334_388815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.499 140C162.582 140 135 110.837 135 74.985C135 39.1338 162.582 10 196.499 10C230.416 10 258 39.1613 258 75.0062C258 110.851 230.41 140 196.499 140ZM196.499 30.806C174.165 30.806 155.994 50.6491 155.994 74.985C155.994 99.3209 174.165 119.172 196.499 119.172C218.835 119.172 236.998 99.3284 236.998 74.985C236.998 50.6428 218.827 30.806 196.499 30.806Z",
    fill: "#FFC814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.bf9082600fb6d9610b353ac384b6c486.svg";
export { ForwardRef as ReactComponent };